import React from 'react'
import '../sass/progressbar.sass'

function ProgressBar({percentage, backgroundColor}) {
  return (
    <div className='progressBar'>
        <div className='progressBarInner' style={{width: `${percentage}%`, background: `${backgroundColor}`}}>
            <span className='progressPercentage' style={{background: `${backgroundColor}`}}>{percentage}%</span>
        </div>
    </div>
  )
}

export default ProgressBar